import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // 🔹 IMPORTANTE
import { useAuth } from "../context/AuthContext";
import Pesquisa from "./Pesquisa/Pesquisa";
import logo from "../img/logo - senai-ited.svg";

function Menu({ texto, onTextoChange, onPesquisar, aoIrHome }) {
  const [menuAberto, setMenuAberto] = useState(false);

  /* 🔹 Hook de navegação do React Router */
  const navegar = useNavigate();
  const location = useLocation();
  /* 🔹 Hook de autenticação */
  const { isLoggedIn, logout } = useAuth();

  const secoes = [
    { titulo: "Realidade Virtual", id: "secao-rv" },
    { titulo: "Realidade Aumentada", id: "secao-ra" },
    { titulo: "Vídeo 360", id: "secao-video360" },
    { titulo: "Vídeo 360i", id: "secao-video360i" },
  ];

  function irParaSecao(id) {

    /* 🔹 limpa pesquisa primeiro */
    if (aoIrHome) {
      aoIrHome();
    }

    if (location.pathname === "/") {
      const elemento = document.getElementById(id);

      if (elemento) {
        elemento.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    navegar("/#" + id);
  }

  /* 🔹 Função para voltar à página inicial */
  function irParaInicio() {
    navegar("/");

    /* opcional: rolar para o topo */
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /* 🔹 Função para ir para área administrativa */
  function irParaAdmin() {
    navegar("/admin");
  }

  /* 🔹 Função para fazer logout */
  function handleLogout() {
    logout();
    navegar("/");
  }
  
  function irParaLogin() {
    navegar("/login");
  }


  return (
    <nav
      className="menu"
    >
      <div className="container menu-container">
        {/* Logo clicável */}
        <div
          className="espacoLogo"
          onClick={irParaInicio}
          style={{ cursor: "pointer" }} // feedback visual de clique
        >
          <img src={logo} alt="Logo Senai ITED" />
        </div>
        <button
          className="menu-hamburger"
          onClick={() => setMenuAberto(!menuAberto)}
        >
          ☰
        </button>
        {/* Área direita (botões + busca) */}
        <div className={`menu-direita ${menuAberto ? "aberto" : ""}`}>

          {/* Botões */}
          <div className="espacoBotoes">
            {secoes.map(function (sec) {
              return (
                <button
                  key={sec.id}
                  onClick={() => irParaSecao(sec.id)}
                  className="botoesMenu"
                >
                  {sec.titulo}
                </button>
              );
            })}

            {isLoggedIn && (
              <button
                onClick={irParaAdmin}
                className="botoesMenu btn-admin"
              >
                Admin
              </button>
            )}

            {/* comentei aqui para que o botao de entrar nao apareça conforme solicitaçao do meu lider(Igor) */}
            {/* <button
              onClick={isLoggedIn ? handleLogout : irParaLogin}
              className={`botoesMenu ${isLoggedIn ? "btn-logout" : "btn-login-menu"}`}
            >
              {isLoggedIn ? "Sair" : "Entrar"}
            </button> */}

          </div>

        </div>
      </div>
    </nav>
  );
}

export default Menu;
